import React from 'react';
import CollapsibleSection from './CollapsibleSection';

const SectionsPanel = ({ sections }) => {
  if (!sections || typeof sections !== 'object') {
    return (
      <div className="content-empty">
        <div className="content-empty-box">
          <p style={{ fontSize: '1.125rem', fontWeight: '500', marginBottom: '8px' }}>No Sections Available</p>
          <p style={{ fontSize: '0.875rem' }}>No section data found for this document</p>
        </div>
      </div>
    );
  }

  const sectionKeys = Object.keys(sections);

  return (
    <div className="sections-panel">
      <div className="sections-header">
        <h3 className="sections-title">Document Sections</h3>
        <p className="sections-count">{sectionKeys.length} section{sectionKeys.length !== 1 ? 's' : ''}</p>
      </div>
      
      <div className="sections-container">
        {sectionKeys.map((sectionKey, index) => (
          <CollapsibleSection
            key={sectionKey}
            title={sectionKey.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim()}
            content={sections[sectionKey]}
            isDefaultOpen={index === 0} // First section auto-expanded
            sectionKey={sectionKey}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionsPanel;
